var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74CD80"
    },
    d: "M349.409,372.151c0-56.42-45.902-102.323-102.324-102.323v-36.35 c76.465,0,138.673,62.208,138.673,138.673H349.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC90D9"
    },
    d: "M385.759,372.151c0-76.465-62.208-138.673-138.673-138.673v-36.349 c96.662,0,175.023,78.36,175.023,175.023L385.759,372.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6EA4"
    },
    d: "M313.06,372.151c0-36.377-29.596-65.973-65.974-65.973v-36.35 c56.422,0,102.324,45.902,102.324,102.323H313.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAEA"
    },
    d: "M478.23,362.59c-3.968,0-7.777,0.671-11.331,1.89c-12.418-26.38-39.236-44.643-70.323-44.643 c-25.432,0-48.009,12.221-62.181,31.111c-4.876-1.623-10.086-2.514-15.507-2.514c-23.888,0-43.791,17.062-48.187,39.664 c-0.951,4.89,2.828,9.427,7.809,9.427h225.521c5.3,0,9.169-5.108,7.627-10.179C507.3,373.017,493.983,362.59,478.23,362.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M396.575,319.837c-2.617,0-5.203,0.137-7.754,0.389 c28.441,3.049,54.439,24.293,65.926,48.696c2.148,4.163,7.027-1.864,12.151-4.443C454.481,338.1,427.663,319.837,396.575,319.837z  M511.658,387.345c-4.358-14.329-17.675-24.755-33.428-24.755c-2.516,0-4.968,0.272-7.332,0.78 c12.426,2.669,22.398,11.947,26.056,23.975c1.542,5.071-2.326,10.179-7.626,10.179h14.705 C509.331,397.524,513.2,392.416,511.658,387.345z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4D06D"
    },
    cx: 175,
    cy: 256,
    r: 107.84
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M174.995,148.158c-2.18,0-4.342,0.072-6.49,0.2 C225.042,151.715,269.857,198.62,269.857,256s-44.815,104.285-101.352,107.642c2.148,0.128,4.31,0.2,6.49,0.2 c59.559,0,107.842-48.283,107.842-107.842C282.837,196.44,234.555,148.158,174.995,148.158z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M174.995,125.972c-4.142,0-7.5-3.357-7.5-7.5V92.395c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v26.077C182.495,122.614,179.137,125.972,174.995,125.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M77.745,166.253c-1.746,0-3.5-0.606-4.92-1.843l-21.189-18.439 c-3.125-2.719-3.454-7.456-0.734-10.581c2.72-3.125,7.458-3.452,10.581-0.733l21.189,18.439c3.125,2.719,3.454,7.456,0.734,10.581 C81.922,165.381,79.839,166.253,77.745,166.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M37.466,263.5H7.5c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h29.966c4.142,0,7.5,3.357,7.5,7.5 S41.608,263.5,37.466,263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M56.561,379.186c-2.094,0-4.178-0.872-5.661-2.576c-2.719-3.125-2.391-7.862,0.734-10.581 l21.189-18.439c3.124-2.72,7.861-2.392,10.581,0.733c2.719,3.125,2.391,7.862-0.734,10.581l-21.189,18.44 C60.061,378.58,58.307,379.186,56.561,379.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M174.995,427.105c-4.142,0-7.5-3.358-7.5-7.5v-26.077c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v26.077C182.495,423.748,179.137,427.105,174.995,427.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M293.429,379.186c-1.746,0-3.5-0.606-4.92-1.843l-21.189-18.44 c-3.125-2.719-3.454-7.456-0.734-10.581c2.72-3.124,7.458-3.451,10.581-0.733l21.19,18.439c3.125,2.719,3.454,7.456,0.734,10.581 C297.607,378.315,295.523,379.186,293.429,379.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M342.49,263.5h-29.966c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h29.966 c4.142,0,7.5,3.357,7.5,7.5S346.632,263.5,342.49,263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M272.246,166.253c-2.094,0-4.178-0.872-5.661-2.576c-2.719-3.125-2.391-7.862,0.734-10.581 l21.189-18.439c3.124-2.72,7.861-2.393,10.581,0.733c2.719,3.125,2.391,7.862-0.734,10.581l-21.19,18.439 C275.746,165.646,273.992,166.253,272.246,166.253z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M185.619,272.183c-3.719,0-7.171-1.165-10.009-3.15c-2.839,1.985-6.291,3.15-10.009,3.15 c-9.655,0-17.509-7.854-17.509-17.509c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,1.384,1.125,2.509,2.509,2.509 s2.509-1.125,2.509-2.509c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,1.384,1.125,2.509,2.509,2.509s2.51-1.125,2.51-2.509 c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5C203.128,264.328,195.273,272.183,185.619,272.183z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M110.448,277.775H98.887c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h11.561 c4.142,0,7.5,3.357,7.5,7.5S114.59,277.775,110.448,277.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M252.331,277.775H240.77c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h11.561 c4.142,0,7.5,3.357,7.5,7.5C259.832,274.418,256.474,277.775,252.331,277.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M112.454,255.782c-4.142,0-7.5-3.357-7.5-7.5c0-0.158-0.128-0.286-0.286-0.286 s-0.286,0.128-0.286,0.286c0,4.143-3.358,7.5-7.5,7.5s-7.5-3.357-7.5-7.5c0-8.429,6.857-15.286,15.286-15.286 s15.286,6.857,15.286,15.286C119.954,252.425,116.596,255.782,112.454,255.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M254.337,255.782c-4.142,0-7.5-3.357-7.5-7.5c0-0.158-0.128-0.286-0.286-0.286 s-0.286,0.128-0.286,0.286c0,4.143-3.358,7.5-7.5,7.5s-7.5-3.357-7.5-7.5c0-8.429,6.857-15.286,15.286-15.286 s15.286,6.857,15.286,15.286C261.837,252.425,258.479,255.782,254.337,255.782z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.665b4267.svg";
export { ForwardRef as ReactComponent };